import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {injectIntl} from 'react-intl';
import InsightList from './list';

class ExpenseReportPortfolioDummy extends Component {
	createDummy(
		name,
		cost,
		price,
		markup,
		quantity,
		expenseCategory,
		date,
		billable,
		notes,
		projectId,
		projectName,
		client,
		createdAt,
		createdBy,
		updatedAt,
		updatedBy
	) {
		const res = {};
		res.name = name;
		res.cost = '$' + this.props.intl.formatNumber(cost);
		res.price = price ? '$' + this.props.intl.formatNumber(price) : '';
		res.markup = markup ? this.props.intl.formatNumber(markup) + '%' : '';
		res.quantity = this.props.intl.formatNumber(quantity);
		res.expenseCategory = expenseCategory;
		res.billable = billable ? 'Yes' : 'No';
		res.approved = 'Yes';
		res.date = date;
		res.person = {firstName: 'John', lastName: 'Doe', profilePictureDefaultId: 0, profilePictureId: null};
		res.notes = notes;
		res.createdAt = createdAt;
		res.createdBy = createdBy;
		res.updatedAt = updatedAt;
		res.updatedBy = updatedBy;
		res.companyProjectId = `P-${projectId}`;
		res.projectName = projectName;
		res.client = client;
		return res;
	}

	render() {
		let data = [];
		data.push(
			this.createDummy(
				'First expense',
				250,
				500,
				100,
				1,
				'Lodging',
				'01/01/2018',
				true,
				null,
				1,
				'First project',
				'First client',
				'01/01/2018',
				'John Doe',
				'01/01/2018',
				'John Doe'
			)
		);
		data.push(
			this.createDummy(
				'Second expense',
				100,
				null,
				null,
				2,
				'Meals',
				null,
				false,
				null,
				2,
				'Second project',
				'Second client',
				'01/01/2018',
				'John Doe',
				'01/01/2018',
				'John Doe'
			)
		);
		data.push(
			this.createDummy(
				'Third expense',
				100,
				150,
				50,
				1,
				'Entertainment',
				'01/01/2018',
				true,
				null,
				2,
				'Second project',
				'Second client',
				'01/01/2018',
				'John Doe',
				'01/01/2018',
				'John Doe'
			)
		);
		data.push(
			this.createDummy(
				'Fourth expense',
				250,
				null,
				null,
				2,
				'Entertainment',
				null,
				false,
				'Notes about expense',
				3,
				'Third project',
				'Third client',
				'01/01/2018',
				'John Doe',
				'01/01/2018',
				'John Doe'
			)
		);
		data.push(
			this.createDummy(
				'Fifth expense',
				200,
				null,
				null,
				2,
				'Mileage',
				'01/01/2018',
				false,
				null,
				3,
				'Third project',
				'Third client',
				'01/01/2018',
				'John Doe',
				'01/01/2018',
				'John Doe'
			)
		);
		return (
			<InsightList
				data={data}
				componentName={this.props.componentName}
				allColumns={this.props.allColumns}
				activeColumns={this.props.activeColumns}
				scrollElement={this.props.scrollElement}
				notifyOnReady={this.props.notifyOnReady}
			/>
		);
	}
}

ExpenseReportPortfolioDummy.propTypes = {
	title: PropTypes.string,
};

export default injectIntl(ExpenseReportPortfolioDummy);
